import { Dispatch, SetStateAction, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { useAuth } from '@/hooks/useAuth/useAuth';
import { appHubIndexPath } from '@/utils/constants';
import { cn } from '@/utils/tailwind';

import Layout from '../Layout';
import { NavLinks } from './NavLinks';
import { WorkspacePicker } from './WorkspacePicker';

const NavHeader = ({
  expanded,
  setExpanded,
}: {
  expanded: boolean;
  setExpanded: Dispatch<SetStateAction<boolean>>;
}) => {
  const auth = useAuth();

  const { pathname } = useLocation();
  const inHub = pathname.split('/')[1] === appHubIndexPath;

  const scrollContainerRef = useRef(null);

  return (
    <Layout.Header
      expanded={expanded}
      setExpanded={setExpanded}
      ref={scrollContainerRef}
    >
      <div
        className={cn('flex flex-1 flex-col', expanded ? 'px-0' : 'px-2.5 ')}
      >
        <NavLinks
          auth={auth}
          expanded={expanded}
          setExpanded={setExpanded}
          scrollContainerRef={scrollContainerRef}
        />

        {!inHub && <WorkspacePicker expanded={expanded} />}
      </div>
    </Layout.Header>
  );
};

export default NavHeader;
